import React from 'react'
import './Splash.css'
const Splash = () => {
  return (
    <div
    className="splash-screen">
    <img
      className="splash-image"
      src="/images/fintechscorecard.png"
      alt="splash Image"
    />
    <div className="loader"></div>
  </div>
  )
}

export default Splash